import React from "react";
import Dropdown from "./Dropdown";
import "./styles/FilterLogicOperator.scss";

interface FilterLogicOperatorProps {
  value: string;
  onChange: (value: string) => void;
}

const FilterLogicOperator: React.FC<FilterLogicOperatorProps> = ({
  value,
  onChange
}) => {
  const options = ["And", "Or"];

  return (
    <div className="filter-logic">
      <Dropdown
        options={options}
        value={value}
        onChange={onChange}
        className="filter-logic__dropdown"
      />
    </div>
  );
};

export default FilterLogicOperator;
